import { create } from "zustand"

const initialState = {
  readOnly: true,
  isReviewerView: false,
  showVersionCompare: false,
  showPagePreview: false,
  formView: { id: "global", text: "Global" },
  formSection: { id: "protocol", text: "Protocol" },
  formStatus: "init",
  showRegistryBadges: false,
  currDataSchema: null,
  currUISchema: null,
  showPanel: localStorage.getItem("SHOW_PANEL") === "false" ? false : true,
  showNav: localStorage.getItem("SHOW_AUTHORING_FORM_NAV") === "false" ? false : true,
  refreshFormData: false,
  fullScreen: false,
  customTableWidthClassName: "",
  formWidthClassName: "",
  showDeleteForkModal: false,
  forkPathToDelete: null,
  forkRegToDelete: null,
  showUniqueRegistryPreviewType: null,
  panelView: "comments",
  loadingForm: false,
}

const useAuthoringViewStore = create((set) => ({
  ...initialState,
  setReadOnly: (readOnly) => set({ readOnly }),
  setIsReviewerView: (isReviewerView) => set({ isReviewerView }),
  setShowVersionCompare: (showVersionCompare) => set({ showVersionCompare }),
  setShowPagePreview: (showPagePreview) => set({ showPagePreview }),
  setFormView: (formView) => set({ formView }),
  setFormSection: (formSection) => set({ formSection }),
  setFormStatus: (formStatus) => set({ formStatus }),
  setShowRegistryBadges: (showRegistryBadges) => set({ showRegistryBadges }),
  setCurrDataSchema: (currDataSchema) => set({ currDataSchema }),
  setCurrUISchema: (currUISchema) => set({ currUISchema }),
  setShowPanel: (showPanel) => set({ showPanel }),
  setShowNav: (showNav) => set({ showNav }),
  setFullScreen: (fullScreen) => set({ fullScreen }),
  setRefreshFormData: (refreshFormData) => set({ refreshFormData }),
  resetAuthoringViewStore: () => set(initialState),
  setCustomTableWidthClassName: (customTableWidthClassName) => set({ customTableWidthClassName }),
  setFormWidthClassName: (formWidthClassName) => set({ formWidthClassName }),
  setShowDeleteForkModal: (showDeleteForkModal) => set({ showDeleteForkModal }),
  setForkPathToDelete: (forkPathToDelete) => set({ forkPathToDelete }),
  setForkRegToDelete: (forkRegToDelete) => set({ forkRegToDelete }),
  setShowUniqueRegistryPreviewType: (showUniqueRegistryPreviewType) => set({ showUniqueRegistryPreviewType }),
  setPanelView: (panelView) => set({ panelView }),
  setLoadingForm: (loadingForm) => set({ loadingForm }),
}))

export default useAuthoringViewStore
